import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class MonitorEmbarque {
  static async getMonitorEmbarqueBuque () {
    const axios = getAxiosInstance()
    const promise = axios.get('monitor_embarque_buque')
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static async getMonitorEmbarqueExportador () {
    const axios = getAxiosInstance()
    const promise = axios.get('monitor_embarque_exportador')
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static async getMonitorEmbarqueBodega () {
    const axios = getAxiosInstance()
    const promise = axios.get('monitor_embarque_bodega')
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }
}

export default MonitorEmbarque
